import React from 'react';
import { FloorPlanStatus } from 'auto-design-common';
import { ProcessingBadge, ReadyBadge } from './StatusBadge';

const MAP = {
  [FloorPlanStatus.CREATED]: ProcessingBadge,
  [FloorPlanStatus.READY]: ReadyBadge,
};

export default function ImageStatusBadge({ status }) {
  const Comp = MAP[status];

  if (!Comp) {
    return null;
  }

  return <Comp />;
}
